/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Sync_Debt_LabelInputs */

const vi_import_sync_debt_label = /** @type {(inputs: Import_Sync_Debt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ công nợ theo file`)
};

/**

* @param {Import_Sync_Debt_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_sync_debt_label = /** @type {((inputs?: Import_Sync_Debt_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Sync_Debt_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_sync_debt_label(inputs)
});